/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  ManagerLogic3,
  ManagerLogic3Interface,
} from "../../../contracts/manager/ManagerLogic3";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "ticketId",
        type: "bytes32",
      },
    ],
    name: "TicketWithdraw",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "ticketId",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "category",
            type: "bytes32",
          },
        ],
        internalType: "struct ManagerType.WithdrawRequestV2",
        name: "param",
        type: "tuple",
      },
    ],
    name: "getWithdrawRequestV2DataHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "ticketId",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "category",
            type: "bytes32",
          },
        ],
        internalType: "struct ManagerType.WithdrawRequestV2",
        name: "param",
        type: "tuple",
      },
    ],
    name: "getWithdrawRequestV2Hash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getWithdrawRequestV2TypeHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "ticketIds",
        type: "bytes32[]",
      },
    ],
    name: "ticketStatus",
    outputs: [
      {
        internalType: "bool[]",
        name: "",
        type: "bool[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "ticketId",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "category",
            type: "bytes32",
          },
        ],
        internalType: "struct ManagerType.WithdrawRequestV2",
        name: "param",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
        ],
        internalType: "struct ManagerType.Signature",
        name: "signature",
        type: "tuple",
      },
    ],
    name: "verifyWithdrawRequestV2",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "ticketId",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "who",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "category",
            type: "bytes32",
          },
        ],
        internalType: "struct ManagerType.WithdrawRequestV2",
        name: "param",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
        ],
        internalType: "struct ManagerType.Signature",
        name: "signature",
        type: "tuple",
      },
    ],
    name: "withdrawV2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type ManagerLogic3ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ManagerLogic3ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ManagerLogic3__factory extends ContractFactory {
  constructor(...args: ManagerLogic3ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ManagerLogic3> {
    return super.deploy(overrides || {}) as Promise<ManagerLogic3>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ManagerLogic3 {
    return super.attach(address) as ManagerLogic3;
  }
  override connect(signer: Signer): ManagerLogic3__factory {
    return super.connect(signer) as ManagerLogic3__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManagerLogic3Interface {
    return new utils.Interface(_abi) as ManagerLogic3Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManagerLogic3 {
    return new Contract(address, _abi, signerOrProvider) as ManagerLogic3;
  }
}
